export default {
  ['login'](state, payload) {
    state.level = payload.level;
    state.user_id = payload.user_id;
    state.email = payload.email;
    state.access_key = payload.access_key;
  },

  ['logout'](state, payload) {
    state.level = 0;
    state.user_id = null;
    state.email = null;
    state.access_key = null;
  },

  ['updateClear'](state, payload) {
    state.update.old_password = '';
    state.update.new_password = '';
    state.update.retype_password = '';
  },

  ['forgotClear'](state, payload) {
    state.forgot.email = '';
  },

  ['registLoad'](state, payload) {
    state.regist.email = payload.email;
    state.regist.code = payload.code;
    state.regist.password = '';
    state.regist.retype_password = '';
    state.regist.policy = false;
  },

  ['registClear'](state, payload) {
    state.regist.email = '';
    state.regist.code = '';
    state.regist.password = '';
    state.regist.retype_password = '';
    state.regist.policy = false;
  },
};
